module.exports = __webpack_public_path__ + "img/ihumane-white-short.82ec5481.svg";